<div class="connection-picker-container">
  <div class="connection-picker">
    <label class="form-label mb-1">{{ 'dataconnection.singular' | translate }}</label>
    <app-input-with-error [control]="connectionControl" inputType="select" [translateSelect]="false" [selectValues]="connectionValues" [selectNames]="connectionNames"></app-input-with-error>
  </div>
</div>
<app-datatable
  [dataSource]="jobSource"
  [columns]="columns"
  [baseColumns]="baseColumns"
  [identifier]="'jobs'"
  [actionNew]="false"
  [loadOnInit]="false"
  [searchEnabled]="searchEnabled"
  [customActions]="customActions"
  [customTableActions]="customTableActions"
  [filterElements]="filterElements"
  [filtersBesideSearch]="true"
  [columnConfigurationEnabled]="true"
  [customFieldOptions]="customFieldOptions"
  [showPagination]="jobSource.dataConnection?.dataConnectionHandler === DataConnectionType.CSVDataConnection"
  (columnConfigurationChanged)="onColumnConfigurationChanged($event)"
  (showEvent)="show($event.valueOf())">
    <app-empty-table [icon]="'work'"
      [emptyText]="'job.empty_text' | translate"
      [buttonText]="canUploadJobs ? ('job.add_jobs' | translate) : undefined"
      (btnClick)="emptyButtonClick()">
    </app-empty-table>
    </app-datatable>
<app-error [error]="error"></app-error>
